// --------------------------------------------------------------
// Created On: 2026-06-02
// Author: Zachary Thomas
//
// Last Modified: 2026-06-02
// Modified By: Zachary Thomas
//
// Copyright 2026 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import styles from "./StandAloneUnitVisual.module.scss";

// A data visualization for a stand alone unit.
export default function StandAloneUnitVisual(): Component {
  return (
    <div className="row g-0">
      <div className="col-12 col-lg-6">
        <img
          className={styles.base}
          src="/productVisuals/standAloneUnit/standAloneUnit.png"
          alt="Stand Alone Unit Visualization"
        />
      </div>
    </div>
  );
}
